<div class="settings-bans">
  <andor-fieldset [headline]="'Banned Users' | translate" size="fill">
    @if (loading()) {
      <div class="state">{{ 'Loading banned users…' | translate }}</div>
    } @else {
      @if (error()) {
        <div class="notification error">
          <div class="text">{{ error() }}</div>
          <andor-icon-btn (clickHandler)="error.set(null)" [aria-label]="'Dismiss' | translate">
            <fa-icon [icon]="faClose"></fa-icon>
          </andor-icon-btn>
        </div>
      }
      <ul class="ban-list">
        @for (ban of bans(); track ban.userId) {
          <li class="ban-row">
            <div class="info">
              <span class="name">{{ ban.userName || ban.userId }}</span>
              <span class="expiry">
                {{ 'Ban lifts' | translate }}: {{ ban.bannedUntil | localizedDate: 'mediumDate' }}
                <span class="relative">({{ relativeExpiry(ban.bannedUntil) }})</span>
              </span>
            </div>
            <andor-icon-btn
              class="remove"
              [disabled]="removing() === ban.userId"
              [tooltip]="'Lift this ban' | translate"
              (clickHandler)="removeBan(ban)">
              <fa-icon [icon]="faUserCheck"></fa-icon>
            </andor-icon-btn>
          </li>
        } @empty {
          <li class="state empty">
            <fa-duotone-icon [icon]="faBan"></fa-duotone-icon>
            <span>{{ 'No banned users.' | translate }}</span>
          </li>
        }
      </ul>
    }
  </andor-fieldset>
</div>
